export const private_projects = [
  {
    id: "1",
    title: "The Planets",
    img: "https://hamzahfayad.github.io/portfolio/img/projects/planets.png",
    link: "https://hamzahfayad.github.io/planets-facts/",
    topic: ["All Projects", "HTML/SCSS/JS", "JSON"],
  },
  {
    id: "1.2",
    title: "p5.js projects (Generative Art)",
    img: "https://hamzahfayad.github.io/p5.js/images/firework.png",
    link: "https://hamzahfayad.github.io/p5.js/",
    topic: ["All Projects", "p5.js"],
  },
  {
    id: "2",
    title: "Github Users",
    img: "https://hamzahfayad.github.io/portfolio/img/projects/devfinder.jpg",
    link: "https://hamzahfayad.github.io/devfinder/",
    topic: ["All Projects", "Vue.js", "API"],
  },
  {
    id: "2.1",
    title: "retro-style Song Box v1.2 (in progress)",
    img: "https://raw.githubusercontent.com/HamzahFayad/songbox/main/public/assets/screenshotv1.png",
    link: "https://song-box.netlify.app/",
    topic: ["All Projects", "React"],
  },
  {
    id: "3",
    title: "Weather App",
    img: "https://hamzahfayad.github.io/portfolio/img/projects/weather-app.png",
    link: "https://hamzahfayad.github.io/weather-app/",
    topic: ["All Projects", "Vue.js", "API"],
  },
  {
    id: "4",
    title: "Todo",
    img: "https://hamzahfayad.github.io/portfolio/img/projects/todo.png",
    link: "https://hamzahfayad.github.io/todo/",
    topic: ["All Projects", "Vue.js", "API"],
  },
  // {
  //   id: "5",
  //   title: "Periodic Table Infosite",
  //   img: "/images/elements.png",
  //   link: "https://chemical-elements.netlify.app/",
  //   topic: ["All Projects", "React", "API"],
  // },
  {
    id: "7",
    title: "musAic - shuffle sounds",
    img: "/images/musaic.png",
    link: "https://musaic-shuffle.netlify.app/",
    topic: ["All Projects", "React"],
  },
  {
    id: "8",
    title: "Studio Ghibli",
    img: "https://hamzahfayad.github.io/portfolio/img/projects/studioghibli.JPG",
    link: "https://hamzahfayad.github.io/studioghibli/",
    topic: ["All Projects", "HTML/SCSS/JS"],
  },
  // {
  //   id: "9",
  //   title: "Inpacs Messe | 1920x1080 Screens",
  //   img: "/images/inpacs.png",
  //   link: "https://testserver.glow.berlin/inpacs-messe/",
  //   topic: ["All Projects", "Wordpress"],
  // },
  {
    id: "9",
    title: "glow communication",
    img: "/images/glow.png",
    link: "https://glow-berlin.de/",
    topic: ["All Projects", "Wordpress"],
  },
  {
    id: "10",
    title: "Social Media Dashboard",
    img: "https://hamzahfayad.github.io/portfolio/img/projects/social-media-dashboard.jpg",
    link: "https://hamzahfayad.github.io/social-media-dashboard/",
    topic: ["All Projects", "HTML/SCSS/JS"],
  },
];
